import React, { useEffect, useMemo, useState } from 'react';
import styled from '@emotion/styled';

import Header from 'components/Common/Header';
import Tab from 'components/Common/Tab';
import TextInput from 'components/Common/TextInput';
import AtlantaParishes from 'components/Parishes&Organizations/AtlantaParishes';
import { Card } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import MuiLoader from 'components/Common/Loader';
import { fetchParishData } from 'redux/slices/parishesAndOrganisations/parishOrganizationSlice';
import { AppDispatch } from '../../redux/store';
import { defaultPageSize } from 'appConfig';
import { debounce } from 'utils/helpers';

const StyledContainer = styled.div({
    backgroundColor: '#F2F2F6',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
});

const StyledActionContainer = styled.div({
    marginBottom: 16,
    padding: 22,
});

const StyledInnerContainer = styled.div({
    backgroundColor: 'white',
    padding: 1,
    marginTop: 10,
});
const Parishes: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [tab, setTab] = useState('atlanta');
    const [pageNumber, setPageNumber] = useState(0);
    const { data: parishData, loading } = useSelector((state: RootState) => state.parish.parishesList);
    const [searchText, setSearchText] = useState<string>('');

    useEffect(() => {
        dispatch(fetchParishData({ searchText, headers: { pageNumber, pageSize: defaultPageSize } }));
    }, [dispatch, pageNumber, tab, searchText]);

    const setTabValue = (value: string) => {
        setTab(value);
    };

    const handleChangeSearch = debounce((e: any) => {
        const { value } = e.target || {};
        setSearchText(value);
    }, 700);

    // let content = useMemo(() => {
    //     switch (tab) {
    //         case 'atlanta':
    //             return <AtlantaParishes data={parishData} />
    //         case 'announcementgroups':
    //             return  <AtlantaParishes data={parishData} />
    //         case 'bankdetails':
    //             return 'No content found!'
    //         default:
    //             return 'No content found!'
    //     }
    // },[tab, parishData])

    return (
        <StyledContainer style={{ borderRadius: 12 }}>
            <MuiLoader loading={loading} absolute />
            <div style={{ padding: 22 }}>
                <Header />
            </div>
            <StyledActionContainer>
                <StyledInnerContainer>
                    <Card sx={{ mb: 1 }}>
                        <div style={{ padding: 16 }}>
                            <TextInput onChange={handleChangeSearch} />
                        </div>
                        {/* <Tab
                            tabs={[
                                { value: 'atlanta', label: 'Atlanta Parishes' },
                                // { value: 'announcementgroups', label: 'Educational Establishments' },
                                // { value: 'hospital', label: 'Hospital and Medical' },
                                // { value: 'other', label: 'Other' },
                            ]}
                            setTabValue={setTabValue}
                        /> */}
                    </Card>
                    {/* <div>{content}</div> */}
                    <AtlantaParishes data={parishData} loading={loading} />
                </StyledInnerContainer>
            </StyledActionContainer>
        </StyledContainer>
    );
};

export default Parishes;
